<template>
  <div v-if="notice.length > 0" class="notice-wrapper">
    <transition name="slide" mode="out-in">
      <p :key="scrollNum">
        {{ notice[scrollNum] }}
      </p>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'ScrollMessage',
  props: {
    notice: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      scrollNum: 0
    }
  },
  mounted() {
    this.timer = window.setInterval(this.autoPlay, 3000)
  },
  destroyed() {
    this.timer && window.clearInterval(this.timer)
  },
  activated() {
    this.timer = window.setInterval(this.autoPlay, 3000)
  },
  deactivated() {
    this.timer && window.clearInterval(this.timer)
  },
  methods: {
    autoPlay() {
      this.scrollNum++
      if (this.scrollNum > this.notice.length - 1) {
        this.scrollNum = 0
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.notice-wrapper {
  width: 100%;
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s linear;
}
.slide-leave-to {
  transform: translateY(-20px);
}
.slide-enter {
  transform: translateY(20px);
}
</style>
